import { render, staticRenderFns } from "./BusinessModelPerspective.vue?vue&type=template&id=d7d0f56a&scoped=true&"
import script from "./BusinessModelPerspective.vue?vue&type=script&lang=js&"
export * from "./BusinessModelPerspective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d0f56a",
  null
  
)

export default component.exports